// AUTO-GENERATED by apps/web/scripts/gen-sig-lookups.mjs — DO NOT EDIT BY HAND.
// Re-run the generator to refresh from apps/api/data/terms/*.csv.
// Lookup convention (ADR-011): store the code in the medication row, resolve
// the display name here. system= tags: route=fhir-route, form=fhir-doseform,
// frequency=fhir-timing, dose_units=ucum.

export type SigLookup = { code: string; name: string }

export const ROUTES: SigLookup[] = [
  { code: "Oral", name: "Oral" },
  { code: "Sublingual", name: "Sublingual" },
  { code: "Topical", name: "Topical" },
  { code: "IV", name: "Intravenous" },
  { code: "IM", name: "Intramuscular" },
  { code: "SC", name: "Subcutaneous" },
  { code: "Inhalation", name: "Inhalation" },
  { code: "Rectal", name: "Rectal" },
  { code: "Ophthalmic", name: "Ophthalmic" },
  { code: "Otic", name: "Otic" },
  { code: "Transdermal", name: "Transdermal" },
]

export const FORMS: SigLookup[] = [
  { code: "Tablet", name: "Tablet" },
  { code: "Capsule", name: "Capsule" },
  { code: "Solution", name: "Solution" },
  { code: "Suspension", name: "Suspension" },
  { code: "Cream", name: "Cream" },
  { code: "Ointment", name: "Ointment" },
  { code: "Patch", name: "Patch" },
  { code: "Inhaler", name: "Inhaler" },
  { code: "Injection", name: "Injection" },
  { code: "Eye drops", name: "Eye drops" },
  { code: "Ear drops", name: "Ear drops" },
  { code: "Suppository", name: "Suppository" },
]

export const FREQUENCIES: SigLookup[] = [
  { code: "OD", name: "Once daily" },
  { code: "BID", name: "Twice daily" },
  { code: "TID", name: "Three times daily" },
  { code: "QID", name: "Four times daily" },
  { code: "QHS", name: "At bedtime" },
  { code: "PRN", name: "As needed" },
  { code: "Q4H", name: "Every 4 hours" },
  { code: "Q6H", name: "Every 6 hours" },
  { code: "Q8H", name: "Every 8 hours" },
  { code: "Weekly", name: "Once weekly" },
  { code: "PRN-as-needed", name: "As needed (PRN)" },
]

export const DOSE_UNITS: SigLookup[] = [
  { code: "mg", name: "milligram" },
  { code: "mcg", name: "microgram" },
  { code: "g", name: "gram" },
  { code: "mL", name: "milliliter" },
  { code: "L", name: "liter" },
  { code: "IU", name: "international unit" },
  { code: "%", name: "percent" },
  { code: "tab", name: "tablet" },
  { code: "cap", name: "capsule" },
  { code: "puff", name: "puff" },
  { code: "drop", name: "drop" },
  { code: "unit", name: "unit" },
  { code: "patch", name: "patch" },
]
